import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useQuarterlyStartAssessment = (
  isLoading,
  isStarted,
  transactionStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed =
    [
      'PENDING',
      'EXPIRED SOA',
      'EXPIRED REFERENCE NUMBER',
      'REASSESSING',
    ].indexOf(transactionStatus) > -1;

  const isAllowed = true && isStatusAllowed;

  const onStartAssessment = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want ${isStarted ? 'Stop' : 'Start'} reassessment?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = isAllowed ? (
    <div className="mx-2">
      <button
        disabled={isLoading}
        onClick={onStartAssessment}
        type="button"
        className={`btn ${
          isStarted
            ? 'btn-danger'
            : 'btn-primary cms-bg-color-primary cms-outline-primary    '
        } font-weight-bold`}
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        {isStarted ? `Stop` : `Start`} Reassessment{' '}
        <i className={`ml-1 fas ${isStarted ? 'fa-times' : 'fa-check'}`} />
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onStartAssessment,
    component,
  };
};

export default useQuarterlyStartAssessment;
